import useCoverMenu from './useCoverMenu.hook';
import GameButton from '@/shared/GameComponents/UI/GameAnswerButton/GameButton';
import {
  GameAssetsContext,
  GameAssetsContextProvider,
} from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';
import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import GameCoverMenu from '@/shared/GameComponents/UI/CoverMenu/CoverMenu';

export default function CoverMenu({
  activity,
  activityConf,
  gameActions,
  mode,
}) {
  const { state, actions } = useCoverMenu({
    activity,
    activityConf,
    gameActions,
  });
  if (!mode && activityConf.progress) {
    mode = 'multipleChoice';
  }

  return (
    <GameAssetsContextProvider
      gameAssetsFolder={state.gameAssetsFolder}
      gameData={activity.data}
      prepareAssets={actions.prepareCoverAssets}
    >
      <GameAssetsContext.Consumer>
        {(gameAssets) =>
          gameAssets.state.isReady ? (
            <GameCoverMenu
              activity={activity}
              coverImageSrc={`${gameAssets.state.images.cover.src}?v=1`}
            >
              {
                {
                  TYPE: state.availableTypes.map((type) => (
                    <GameButton
                      type="primary"
                      key={type}
                      onClick={() =>
                        gameActions.setGameConf({ miniactivityType: type })
                      }
                    >
                      {typeLabel('game', 'classic', type)}
                    </GameButton>
                  )),
                  LEVEL: (
                    <>
                      {state.availableLevels.map((level) => (
                        <GameButton
                          type="primary"
                          key={level}
                          onClick={() => gameActions.setGameConf({ level })}
                        >
                          {level.toUpperCase()}
                        </GameButton>
                      ))}
                      <GameButton
                        type="secondary"
                        key="back"
                        onClick={() =>
                          gameActions.setGameConf({ miniactivityType: null })
                        }
                      >
                        BACK
                      </GameButton>
                    </>
                  ),
                  START: (
                    <>
                      {activityConf.miniactivityType == 'conceptRace' ? (
                        mode ? (
                          <GameButton
                            type="primary"
                            onClick={() => actions.startGame({ mode })}
                          >
                            START{' '}
                            {mode == 'writing'
                              ? '(Typing Mode)'
                              : '(Multiple Choice)'}
                          </GameButton>
                        ) : (
                          <>
                            <GameButton
                              className="normal-case"
                              type="primary"
                              key="normal-mode"
                              onClick={() =>
                                actions.startGame({ mode: 'multipleChoice' })
                              }
                            >
                              START (Multiple Choice)
                            </GameButton>
                            <p className="option-info">
                              Choose between 3 possible answers.
                            </p>
                            <GameButton
                              className="normal-case"
                              type="primary"
                              key="writing-mode"
                              onClick={() =>
                                actions.startGame({ mode: 'writing' })
                              }
                            >
                              START (Typing Mode)
                            </GameButton>
                            <p className="option-info">Type your answer.</p>
                          </>
                        )
                      ) : (
                        <GameButton type="primary" onClick={actions.startGame}>
                          START
                        </GameButton>
                      )}
                      {activityConf.menu ? (
                        <GameButton
                          type="secondary"
                          onClick={() => {
                            if (state.availableLevels.length > 1) {
                              gameActions.setGameConf({ level: null });
                            } else {
                              gameActions.setGameConf({
                                miniactivityType: null,
                                level: null,
                              });
                            }
                          }}
                        >
                          BACK
                        </GameButton>
                      ) : null}
                    </>
                  ),
                }[state.screen]
              }
            </GameCoverMenu>
          ) : null
        }
      </GameAssetsContext.Consumer>
    </GameAssetsContextProvider>
  );
}
